// extracted by mini-css-extract-plugin
module.exports = {"slider-milestone-item":"style_slider-milestone-item__YcyMl","slider-milestone-item__label":"style_slider-milestone-item__label__H1kYu"};